import React from "react";
import Home from "@dynamicPages/home";
import Layout from "@globals/Layout";
import { GlobalStyle } from "@globals/GlobalStyle";
import { LightboxContextProvider } from "@contexts/lightboxContext";

export default function Template({ pageContext }) {
  return (
    <>
      {pageContext && pageContext.contentful_id && (
        <Layout
          navigationList={pageContext.navigation_menu}
          logo={pageContext.logo}
        >
          <LightboxContextProvider>
            <GlobalStyle />
            <Home block={{ contentful_id: pageContext.contentful_id }} />
          </LightboxContextProvider>
        </Layout>
      )}
    </>
  );
}
